import React, { useState, useEffect } from "react";
import { Button, Modal, Space, Form, Input, Col, Row, Select } from "antd";

import apiUpdateDevice from "../../api/deviceRoomP/updateDevice";
import { logDOM } from "@testing-library/dom";

const modelDefault = [
  {
    name: "bticino",
    type: ["lights", "dim", "curtains", "contact", "pir"],
  },
  {
    name: "obotrons",
    type: ["iaq", "emu"],
  },
  {
    name: "cassette",
    type: ["ac"],
  },
  {
    name: "cassette2",
    type: ["ac"],
  },
  {
    name: "allinone",
    type: ["ac"],
  },
  {
    name: "wulian",
    type: ["lights", "dim", "curtains", "contact", "pir", "curtain_tempering"],
  },
  {
    name: "schneider",
    type: ["lights", "dim", "curtains", "contact", "pir"],
  },
];

const ModalEditDevice = ({
  closeModal,
  open,
  submitModal,
  dataDevice,
  dataTypeAll,
  bticino,
  device,
  deviceName,
  deviceHouse,
  model,
  authUser,
}) => {
  const [formData] = Form.useForm();
  const [openModal, setOpenModal] = useState(false);
  const [typeAll, setTypeAll] = useState([]);
  const [deviceIe, setDeviceIe] = useState([]);

  const [chooseType, setChooseType] = useState(false);

  const [optionBticino, setOptionBticino] = useState([]);
  const [optionDevice, setOptionDevice] = useState([]);
  const [optionDeviceName, setOptionDeviceName] = useState([]);
  const [optionModel, setOptionModel] = useState([]);
  const [optionType, setOptionType] = useState([]);

  const handleCancel = () => {
    setOpenModal(false);
    closeModal();
  };

  const onChangeModel = (value) => {
    var optType = [];
    const match = modelDefault.find((m) => m.name === value.name);

    if (match) {
      optType.push(
        ...match.type
          .map((t) => {
            const found = typeAll.find((e) => e.name === t);
            return found ? { ...found, model: match["name"] } : null;
          })
          .filter(Boolean), // กัน null/undefined
      );
    }
    setOptionType(optType);
  };

  const onChangType = (value) => {
    if (
      value["name"] === "lights" ||
      value["name"] === "dim" ||
      value["name"] === "curtains" ||
      value["name"] === "contact" ||
      value["name"] === "pir"
    ) {
      if (value["model"] === "bticino") {
        setChooseType(true);
      } else {
        setChooseType(false);
      }
    } else {
      setChooseType(false);
    }
  };

  const onFinish = (value) => {
    console.log(value);

    var data = {
      // id: dataDevice["id"].toString(),
      room_id: dataDevice["room_id"].toString(),
      mac_id: value["mac_id"].toString(),
      device_id: value["device_id"].toString(),
      device_name: value["device_name"].toString(),
      device_model: value["device_model"].toString(),
      device_type: value["device_type"].toString(),
      // macid_id: dataDevice["macid_id"].toString(),
    };

    var checkModel =
      model.find((e) => e.id === value["device_model"])?.name || null;

    if (checkModel === "bticino") {
      var checkBticino =
        optionBticino.find((e) => e.value === value["mac_id"])?.home_id || null;
      var checkBticinoMacId =
        optionBticino.find((e) => e.value === value["mac_id"])?.macid_id ||
        null;

      if (checkBticino) {
        data["mac_id"] = checkBticino;
      } else {
        data["mac_id"] = checkBticinoMacId;
      }
    }

    apiUpdateDevice(authUser, data, dataDevice["id"], (err, res) => {
      if (!err && res.statusCode === 200) {
        formData.resetFields();
        submitModal(true, res.statusCode);
        setOpenModal(false);
      } else {
        submitModal(false, res.statusCode);
      }
    });
  };

  const actionSetData = () => {
    setChooseType(false);

    // console.log(dataDevice);
    setDeviceIe(dataDevice);

    var modelFormData = {
      device_model: dataDevice["device_model_id"],
      device_type: dataDevice["device_type_id"],
      mac_id: dataDevice["mac_id"],
      device_id: dataDevice["device_id"],
      device_name: dataDevice["device_name_id"],
    };

    if (
      dataDevice["device_model"] === "bticino" ||
      dataDevice["device_model"] === "wulian" ||
      dataDevice["device_model"] === "schneider"
    ) {
      var checkBticino =
        bticino.find(
          (e) =>
            e.value ===
            `${dataDevice["mac_id"]}-${dataDevice["device_id_name"]}`,
        )?.value || null;

      if (checkBticino) {
        modelFormData["mac_id"] = checkBticino;
        setChooseType(true);
      }
    }

    const matchedDeviceBticino = bticino.filter(
      (h) =>
        !deviceHouse.some(
          (d) =>
            d.device_id_name === h.modules_name &&
            d.device_id_name !== dataDevice["device_id_name"],
        ),
    );

    var optType = [];
    const match = modelDefault.find(
      (m) => m.name === dataDevice["device_model"],
    );

    if (match) {
      optType.push(
        ...match.type
          .map((t) => {
            const found = dataTypeAll.find((e) => e.name === t);
            return found ? { ...found, model: match["name"] } : null;
          })
          .filter(Boolean), // กัน null/undefined
      );
    }
    setOptionType(optType);

    formData.setFieldsValue(modelFormData);

    setTypeAll(dataTypeAll);
    setOptionBticino(matchedDeviceBticino);
    setOptionDevice(device);
    setOptionDeviceName(deviceName);
    setOptionModel(model);
  };

  useEffect(() => {
    actionSetData();

    if (open) {
      setOpenModal(open);
    }
  }, [open]);

  return (
    <Modal
      title={<div style={styles.title}>Edit Dvice</div>}
      open={openModal}
      onCancel={handleCancel}
      footer={null}
      width="550px"
    >
      <Form
        form={formData}
        onFinish={onFinish}
        initialValues={{
          device_model: "",
          device_type: "",
          mac_id: "",
          device_id: "",
          device_name: "",
        }}
      >
        <Form.Item
          label="Model :"
          name="device_model"
          labelCol={{ flex: "100px" }}
        >
          <Select
            showSearch
            style={{
              width: "100%",
            }}
            optionFilterProp="label"
            options={optionModel}
            onChange={(value, option) => {
              onChangeModel(option);
            }}
          />
        </Form.Item>
        <Form.Item
          label="Type :"
          name="device_type"
          labelCol={{ flex: "100px" }}
        >
          <Select
            showSearch
            style={{
              width: "100%",
            }}
            optionFilterProp="label"
            options={optionType}
            onChange={(value, option) => {
              onChangType(option);
            }}
          />
        </Form.Item>

        {chooseType ? (
          <Form.Item
            label="Bticino:"
            name="mac_id"
            labelCol={{ flex: "100px" }}
          >
            <Select
              showSearch
              style={{
                width: "100%",
              }}
              optionFilterProp="label"
              options={optionBticino}
            />
          </Form.Item>
        ) : (
          <>
            <Form.Item label="Mac Address" name="mac_id">
              <Input placeholder="mac address" size="large" />
            </Form.Item>
          </>
        )}

        <Form.Item
          label="Device Id :"
          name="device_id"
          labelCol={{ flex: "100px" }}
        >
          <Select
            showSearch
            style={{
              width: "100%",
            }}
            optionFilterProp="label"
            options={optionDevice}
          />
        </Form.Item>
        <Form.Item
          label="DeviceName :"
          name="device_name"
          labelCol={{ flex: "100px" }}
        >
          <Select
            showSearch
            style={{
              width: "100%",
            }}
            optionFilterProp="label"
            options={optionDeviceName}
          />
        </Form.Item>
        <Row justify="space-between">
          <Col>
            <Button style={styles.buttonCancel} onClick={handleCancel}>
              No
            </Button>
          </Col>
          <Col>
            <Button style={styles.buttonOk} type="primary" htmlType="submit">
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

const styles = {
  layout: {
    fontFamily: "Kanit",
    padding: "20px",
    borderRadius: "8px",
    background: "#FFF",
    marginBottom: "10px",
  },
  title: {
    color: "#4F4F4F",
    fontSize: "20px",
    fontWeight: "500",
    lineHeight: "150%",
    marginBottom: "20px",
  },
  buttonOk: {
    borderRadius: "6px",
    border: "1px solid #FFC700",
    background: "#FFC700",
    boxShadow: "0px 2px 0px 0px rgba(0, 0, 0, 0.02)",
    color: "#FFFFFF",
    fontSize: "16px",
    fontWeight: "400",
    width: "86px",
    height: "40px",
  },
  buttonCancel: {
    borderRadius: "6px",
    border: "1px solid rgba(0, 0, 0, 0.15)",
    background: "#FFF",
    boxShadow: "0px 2px 0px 0px rgba(0, 0, 0, 0.02)",
    color: "#2A5885",
    fontSize: "16px",
    fontWeight: "400",
    width: "86px",
    height: "40px",
  },
};

export default ModalEditDevice;
